// eslint-disable-next-line no-unused-vars
import React from 'react';
import { bool, func, object } from 'prop-types';
import {
  Checkbox,
  ModalFooter,
  TextInput
} from '@carbon/react';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import ProductPreview from './ProductPreview';
import {
  ContentForm,
  Notice,
  PrimaryButton,
  SecondaryButton,
  SubmitLoading
} from './ContentStyles';

const CreateOfferContent = ({
  product,
  validators,
  register,
  rhfErrors,
  setActive,
  loading,
  mustSetActive,
  onSetActive,
  onSubmit,
  onCancel
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const sharedProps = fieldName => ({
    id: `createOffer${ fieldName }`,
    name: fieldName,
    invalid: !!rhfErrors[fieldName]?.message,
    invalidText: rhfErrors[fieldName]?.message,
    ...register(fieldName, { ...validators[fieldName] })
  });

  return (
    <ContentForm theme={ theme } onSubmit={ onSubmit } noValidate>
      <div className="wrapper">
        { product?.id && <ProductPreview product={ product } /> }
        { (mustSetActive || setActive) && (
          <Notice theme={ theme }>
            <strong>{ t('offers.willBecomeActive') }</strong>
            { t('offers.willBecomeActiveDescription') }
          </Notice>
        ) }
        <TextInput
          required
          labelText={ t('offers.offerName') }
          disabled={ loading }
          { ...sharedProps('name') }
        />
        <TextInput
          labelText={ t('offers.client') }
          placeholder={ t('offers.clientPlaceholder') }
          disabled={ loading }
          { ...sharedProps('clientName') }
        />
        <TextInput
          type="email"
          labelText={ t('offers.clientEmail') }
          placeholder={ t('offers.clientPlaceholder') }
          disabled={ loading }
          { ...sharedProps('clientEmail') }
        />
        <Checkbox
          id="createOfferSetActive"
          labelText={ t('offers.setActive') }
          checked={ mustSetActive || setActive }
          disabled={ loading || mustSetActive }
          onChange={ (_, { checked }) => onSetActive(checked) }
        />
        <Notice variant="storage" theme={ theme }>
          { t('offers.storageNote') }
        </Notice>
      </div>
      <ModalFooter>
        <PrimaryButton className="red submit" type="submit" disabled={ loading }>
          { loading && <SubmitLoading status="active" /> }
          { t('offers.createOffer') }
        </PrimaryButton>
        <SecondaryButton kind="ghost" onClick={ onCancel } disabled={ loading }>
          { t('common.cancel') }
        </SecondaryButton>
      </ModalFooter>
    </ContentForm>
  );
};

CreateOfferContent.propTypes = {
  product: object,
  validators: object,
  register: func,
  rhfErrors: object,
  setActive: bool,
  loading: bool,
  mustSetActive: bool,
  onSetActive: func,
  onSubmit: func,
  onCancel: func
};

export default CreateOfferContent;
